import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import Calendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid'; // Import the TimeGrid plugin
import timelinePlugin from '@fullcalendar/timeline';
import { Grid, Modal } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { format } from 'date-fns';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SucessModal from 'src/components/sucess-modal';
import SaveChangesModal from 'src/pages/schedule/save-changes-modal';
import {
  editMyAvailabilityAction,
  getMyAvailabilityAction,
  resetEditMyAvailability,
} from 'src/redux/actions/myAvailabilityAction';
import type { CalendarView } from 'src/types/calendar';
import LoaderIcon from '../../../../src/components/LoaderImg/loader.gif';
import { BootstrapDialog } from '../../common-modals/BootstrapDialog';
import { EditCalendarContainer } from '../../edit-calendar-container';
import '../CalenderStyle/custom-calendar-styles.css';
import { CalendarToolbar } from '../calendar-ttol-bar';
import EditEventContent from './edit-my-Event-calender';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  closeAvialibility: any;
  changedDate: any;
  selectedTherapist: any;
};

const getDateInLocalIsoFormat = (date: any) => {
  const dateNewDate = new Date(date);
  return `${moment(dateNewDate).format('YYYY-MM-DD')}T00:00:00.000Z`;
};

function EditMyAvailability(props: Props) {
  const { closeAvialibility, changedDate, selectedTherapist } = props;
  const dispatch = useDispatch();
  const calendarRef = useRef<Calendar | null>(null);
  const [date, setDate] = useState<Date>(
    format(changedDate, 'MMMM') === format(new Date(), 'MMMM') ? new Date() : changedDate
  );

  const [createPtoRequestError, setCreatePtoRequestError] = useState(false);

  const [successModalTitle, setSuccessModalTitle] = useState({
    title: '',
    message: '',
  });

  const getMyAvailability = useSelector((state: any) => state.getMyAvailabilityReducer);
  const [providerId] = useCurrentUser(['providerId']);
  const editMyAvailabilityResponse = useSelector((state: any) => state.editMyAvailabilityReducer);

  const [view, setView] = useState<CalendarView>('timeGridWeek');

  const [events, setEvents] = useState([]);
  const [editEvent, setEditEvent] = useState([]);
  const [getWeekRange, setGetWeekRange] = useState({
    start: '',
    end: '',
  });
  useEffect(() => {
    if (getMyAvailability?.data?.t1.length !== 0) {
      const getMyAvailabilityEvent = getMyAvailability?.data?.t1.map((dayEvents: any) => {
        function setTimeTo0630(inputDate: any) {
          const [datePart] = inputDate.split('T');
          const modifiedDate = `${datePart}T06:30:00`;
          return modifiedDate;
        }
        return {
          date: dayEvents?.currentDate,
          start: setTimeTo0630(dayEvents?.currentDate),
          uniqueDate: moment(dayEvents?.currentDate, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          isBlocked: dayEvents?.isBlocked,
          end: dayEvents?.currentDate,
          uuid: dayEvents?.uuid,
          dayOfWeek: dayEvents?.dayOfWeek,
          extendedProps: {
            currentDate: dayEvents?.currentDate,
            hours: dayEvents?.hoursAvailable,
            start: dayEvents?.startTime?.substring(0, 2),
            ptoResponses: dayEvents?.ptoResponses,
          },
        };
      });
      setEditEvent(getMyAvailabilityEvent);
      setEvents(getMyAvailabilityEvent);
    }
  }, [getMyAvailability]);

  const handleDatePrev = useCallback((): void => {
    const calendarEl = calendarRef.current;

    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.prev();
      setDate(calendarApi.getDate());
    }
  }, []);

  const handleDateNext = useCallback((): void => {
    const calendarEl = calendarRef.current;

    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.next();
      setDate(calendarApi.getDate());
    }
  }, []);

  const handleAddClick = useCallback((): void => {}, []);

  const handleDateToday = useCallback((): void => {
    const calendarEl = calendarRef.current;

    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.today();
      setDate(calendarApi.getDate());
    }
  }, []);

  const handleViewChange = useCallback((view: CalendarView): void => {
    const calendarEl = calendarRef.current;

    if (calendarEl) {
      const calendarApi = calendarEl.getApi();

      calendarApi.changeView(view);
      setView(view);
    }
  }, []);

  const [saveChangesModal, setSaveChangesModal] = useState(false);
  const [sucessFullRequest, setSucessFullRequest] = useState(false);

  const saveChanges = () => {
    setSaveChangesModal(true);
  };

  const cancelChanges = () => {
    closeAvialibility();
    setSaveChangesModal(false);
  };

  function getWeekEndDate(date: any) {
    const dayOfWeek = date.getDay();
    const daysUntilEndOfWeek = 7 - dayOfWeek;

    const endDate = new Date(date);
    endDate.setDate(date.getDate() + daysUntilEndOfWeek);

    return endDate;
  }

  useEffect(() => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      const start = calendarApi.view.currentStart;
      start.setDate(start.getDate());
      const end = getWeekEndDate(start);
      setGetWeekRange((prev: any) => ({
        ...prev,
        start: calendarApi.view.currentStart,
        end: getWeekEndDate(calendarApi.view.currentStart),
      }));

      dispatch(
        getMyAvailabilityAction({
          startDate: getDateInLocalIsoFormat(start),
          endDate: getDateInLocalIsoFormat(end),
          providerId: selectedTherapist ? selectedTherapist?.uuid : providerId,
        })
      );
    }
  }, [calendarRef, date]);

  const handleSaveThisWeekData = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      const start = calendarApi.view.currentStart;
      start.setDate(start.getDate());
      const end = getWeekEndDate(start);

      const saveEvents = editEvent.map((event: any) => {
        const [datePart, _] = event.date.split('T');
        const startHour = event?.extendedProps?.start;
        const formattedStartHour = String(startHour);
        const setHour =
          formattedStartHour.length === 1 ? `0${formattedStartHour}` : formattedStartHour;
        return {
          uuid: event?.uuid,
          hoursAvailable: event?.extendedProps?.hours,
          dayOfWeek: event?.dayOfWeek,
          startTime: `${datePart}T${setHour}:00:00.00Z`,
          blockThisDay: event?.isBlocked,
          isForFuture: false,
        };
      });
      dispatch(
        editMyAvailabilityAction({
          startDate: getDateInLocalIsoFormat(start),
          endDate: getDateInLocalIsoFormat(end),
          providerId: selectedTherapist ? selectedTherapist?.uuid : providerId,
          data: saveEvents,
        })
      );
    }
  };

  const handleSaveFutureWeekData = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      const start = calendarApi.view.currentStart;
      start.setDate(start.getDate());
      const end = getWeekEndDate(start);

      const saveEvents = editEvent.map((event: any) => {
        const [datePart, _] = event.date.split('T');
        const startHour = event?.extendedProps?.start;
        const formattedStartHour = String(startHour);
        const setHour =
          formattedStartHour.length === 1 ? `0${formattedStartHour}` : formattedStartHour;

        return {
          uuid: event?.uuid,
          hoursAvailable: event?.extendedProps?.hours,
          dayOfWeek: event?.dayOfWeek,
          startTime: `${datePart}T${setHour}:00:00.00Z`,
          blockThisDay: event?.isBlocked,
          isForFuture: true,
        };
      });
      dispatch(
        editMyAvailabilityAction({
          startDate: getDateInLocalIsoFormat(start),
          endDate: getDateInLocalIsoFormat(end),
          providerId: selectedTherapist ? selectedTherapist?.uuid : providerId,
          data: saveEvents,
        })
      );
    }
  };

  useEffect(() => {
    if (
      !editMyAvailabilityResponse.isGetAvailability &&
      editMyAvailabilityResponse?.response === null
    )
      return;

    if (
      !editMyAvailabilityResponse.isGetAvailability &&
      editMyAvailabilityResponse?.response !== null
    ) {
      setSuccessModalTitle((prev) => ({
        ...prev,
        title: 'Error 404',
        message:
          editMyAvailabilityResponse?.response?.message === undefined
            ? 'Cannot edit the request.'
            : editMyAvailabilityResponse?.response?.message,
      }));
      setCreatePtoRequestError(true);
      setSaveChangesModal(false);
      setSucessFullRequest(true);
      dispatch(resetEditMyAvailability());
      return;
    }
    setSuccessModalTitle((prev) => ({
      ...prev,
      title: 'Availability updated successfully',
      message: '',
    }));
    setCreatePtoRequestError(false);
    setSaveChangesModal(false);
    setSucessFullRequest(true);

    dispatch(resetEditMyAvailability());
  }, [editMyAvailabilityResponse]);

  const closeSuccessModal = () => {
    if (
      !editMyAvailabilityResponse.isGetAvailability &&
      editMyAvailabilityResponse?.response !== null
    ) {
      setSucessFullRequest(false);
      return;
    }

    closeAvialibility();
    setSucessFullRequest(false);
  };

  const dayCellClassNames = (arg: any) => {
    const newDate = moment(arg?.date)?.format('MM/DD/YYYY');
    if (editEvent?.length > 0) {
      const matchingEvent = editEvent?.find(
        (event: any) => event.isBlocked && newDate === event.uniqueDate
      );
      if (matchingEvent) {
        return 'custom-date-class';
      }
      return '';
    }
  };

  const renderEventContent = (props: any) => {
    const { event } = props;
    const eventUuid = event?.extendedProps?.uuid;

    return (
      <div key={eventUuid}>
        <EditEventContent
          {...props}
          setEditEvent={setEditEvent}
        />
      </div>
    );
  };

  return (
    <>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Stack>
            <Grid xs={true}>
              <CalendarToolbar
                date={date}
                onAddClick={handleAddClick}
                onDateNext={handleDateNext}
                onDatePrev={handleDatePrev}
                onDateToday={handleDateToday}
                onViewChange={handleViewChange}
                saveChanges={saveChanges}
                getWeekRange={getWeekRange}
                view={view}
                editMode={true}
                close={closeAvialibility}
              />
            </Grid>

            <Card sx={{ mt: 3 }}>
              <EditCalendarContainer>
                {getMyAvailability.loading ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '45vh',
                    }}
                  >
                    <img
                      src={LoaderIcon}
                      alt="loader.."
                    />
                  </div>
                ) : (
                  <Calendar
                    allDayMaintainDuration
                    dayMaxEventRows={3}
                    // droppable={false}
                    // editable={false}
                    eventDisplay="block"
                    eventResizableFromStart={false}
                    headerToolbar={false}
                    initialDate={date}
                    initialView={view}
                    contentHeight={850}
                    selectable={false}
                    displayEventTime={false}
                    // @ts-ignore
                    dayCellClassNames={dayCellClassNames}
                    slotMinTime="00:00:00"
                    allDaySlot={false}
                    slotLabelContent={() => ''}
                    slotEventOverlap={false}
                    events={events}
                    eventContent={renderEventContent}
                    plugins={[
                      dayGridPlugin,
                      interactionPlugin,
                      listPlugin,
                      timeGridPlugin,
                      timelinePlugin,
                    ]}
                    ref={calendarRef}
                    rerenderDelay={10}
                    weekends
                    firstDay={1}
                  />
                )}
              </EditCalendarContainer>
            </Card>
          </Stack>
        </Container>
      </Box>
      <BootstrapDialog
        onClose={() => setSaveChangesModal(false)}
        aria-labelledby="customized-dialog-title"
        open={saveChangesModal}
      >
        <SaveChangesModal
          handleSaveThisWeekData={handleSaveThisWeekData}
          handleSaveFutureWeekData={handleSaveFutureWeekData}
          createPtoRequestError={createPtoRequestError}
          close={cancelChanges}
          isLoading={editMyAvailabilityResponse?.loading}
        />
      </BootstrapDialog>

      <Modal open={sucessFullRequest}>
        <SucessModal
          close={closeSuccessModal}
          isSucess={!createPtoRequestError}
          title={successModalTitle.title}
          message={successModalTitle.message}
        />
      </Modal>
    </>
  );
}

export default EditMyAvailability;
